// extracted by mini-css-extract-plugin
export default {"TextLogo":"App_TextLogo__lgcEB","MainLogo":"App_MainLogo__NNk3q"};